import React from 'react';
import styled from 'styled-components';
import Header from 'components/Header';
import TabNavigation from 'components/TabNavigation';
import { PerformanceProvider } from './context';
import PerformanceFilters from './components/PerformanceFilters';
import Overview from './pages/Overview';
import RestaurantList from './pages/RestaurantList';
import RestaurantDetail from './pages/RestaurantDetail';
import history from '../../history';

const PerformanceContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 20px;
  padding: 20px;

  @media (max-width: 845px) {
    gap: 16px;
    padding: 16px;
  }
`;

const TAB_BUTTONS = [
  { label: 'Overview', route: '/performance' },
  { label: 'Restaurants', route: '/performance/restaurants' }
];

const Performance = () => {
  const pathname = history.location.pathname;

  // Restaurant detail page — different layout
  const detailMatch = pathname.match(/^\/performance\/restaurants\/(\d+)$/);
  if (detailMatch) {
    return (
      <PerformanceProvider>
        <PerformanceContainer>
          <Header title="My Performance" subTitle="Restaurant Detail" />
          <RestaurantDetail restaurantId={parseInt(detailMatch[1], 10)} />
        </PerformanceContainer>
      </PerformanceProvider>
    );
  }

  // Determine active tab page
  const isRestaurantList = pathname === '/performance/restaurants';

  return (
    <PerformanceProvider>
      <PerformanceContainer>
        <Header
          title="My Performance"
          subTitle={isRestaurantList ? 'My Restaurants' : 'Overview'}
        />
        <PerformanceFilters />
        <TabNavigation buttons={TAB_BUTTONS} />
        {isRestaurantList ? <RestaurantList /> : <Overview />}
      </PerformanceContainer>
    </PerformanceProvider>
  );
};

export default Performance;
